import axios from './axios'

import store from '../store'

// lang : ZH_TW、ZH_CN、PT、EN

/**
 * 獲取課程列表
 * @param {*} lang 
 */
const list = (lang = 'ZH_TW') => {
    return axios.get(`${store.state.PCourseId ? '/courses' : store.state.PCourseVersionId ? '/course/versions/preview' : '/course/versions'}?lang=${lang}`).then(res => res.data)
}

/**
 * 獲取課程的章節
 * @param {*} courseId 
 * @param {*} lang 
 */
const getOne = (courseId, lang = 'ZH_TW') => {
    if (!courseId) return false;
    return axios.get(`${store.state.PCourseId ? '/courses' : store.state.PCourseVersionId ? '/course/versions/preview' : '/course/versions'}/${courseId}?lang=${lang}`).then(res => res.data)
}

/**
 * 獲取課程問卷
 * @param {*} courseId 
 * @param {*} lang 
 */
const listQuestionnaireByCourse = (courseId, lang = 'ZH_TW') => {
    return axios.get(`${store.state.PCourseId ? '/courses' : store.state.PCourseVersionId ? '/course/versions/preview' : '/course/versions'}/${courseId}/questionnaires?lang=${lang}`).then(res => res.data)
}

/**
 * 獲取是否要按优先序学习
 * @param {*} courseId 
 * @param {*} lang 
 */
const checkPriority = (courseId, lang = 'ZH_TW') => {
    return axios.get(`${store.state.PCourseId ? '/courses' : store.state.PCourseVersionId ? '/course/versions/preview' : '/course/versions'}/${courseId}/priority?lang=${lang}`).then(res => res.data)
}

/**
 * 獲取是否有模擬考試
 * @param {*} versionId 
 * @param {*} lang 
 * @returns 
 */
const checkHasAssessment = (versionId, lang) => {
    return axios.get(`/course/versions/${versionId}/hasAssessment?lang=${lang}`).then(res => res.data)
}

/**
 * 課程章節記錄瀏覽次數
 * addUserCourseWareWithoutLogin
 * @param {*} courseWareVersionId 
 * @returns 
 */
const recordWares = (courseWareVersionId) => {
    return axios.get(`/course/versions/preview/record/wares/${courseWareVersionId}`).then(res => res.data)
}

/**
 * 課程記錄瀏覽次數
 * addUserCourseWithoutLogin
 * @param {*} versionId 
 * @returns 
 */
const recordCourse = (versionId) => {
    return axios.get(`/course/versions/preview/record/${versionId}`).then(res => res.data)
}

/**
 * 根據code查詢課程詳情
 * @param {*} code 
 * @param {*} lang 
 * @returns 
 */
const getCourseByCode = (code, lang) => {
    return axios.get(`/course/versions/preview/code?code=${code}&lang=${lang}`).then(res => res.data)
}

export default {
    list,
    getOne,
    listQuestionnaireByCourse,
    checkPriority,
    checkHasAssessment,
    recordWares,
    recordCourse,
    getCourseByCode,
}